import React, { createContext } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import WomTheme from './index';
import useMediaQuery from '@mui/material/useMediaQuery';
var MediaQueryContext = createContext({
  md: false
});
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
    _ref$normalize = _ref.normalize,
    normalize = _ref$normalize === void 0 ? true : _ref$normalize;
  var md = useMediaQuery('(min-width:768px)');
  return React.createElement(MediaQueryContext.Provider, {
    value: {
      md: md
    }
  }, React.createElement(MuiThemeProvider, {
    theme: WomTheme
  }, normalize && React.createElement(CssBaseline, null), children));
};
export { ThemeProvider as default, MediaQueryContext };